<template lang="pug">
v-container(fluid class="tw-p-0 tw-m-0")
  div(class="tw-rounded-md tw-border tw-border-dashed tw-border-blueGray-lighten-4")
    v-form(ref="form" v-model="valid" lazy-validation)
      v-row(no-gutters align="center" justify="space-between" class="tw-mx-4")
        v-col(cols="8")
          v-row(no-gutters align="center")
            v-col(cols="auto" class="tw-ml-2")
              v-checkbox(
                v-model="task.status"
                false-value=0
                true-value=1
                background-color="#ffffff"
                :ripple="false"
                color=" indigo lighten-2"
              )
            v-col(cols="stretch" class=" tw--ml-2")
              v-text-field(
                v-model="task.name"
                single-line
                solo
                full-width
                flat
                hide-details
                :placeholder="$t('Opportunities.Common.addTaskPlaceholder') + '...'"
                class=" tw-text-kPurple tw-border-none"
                @keyup.native.enter="valid && submit($event)"
              )
              v-text-field(class=" tw-hidden")

        v-col(cols="4")
          v-row(no-gutters justify="end")
            v-col(cols="auto")
              v-menu(
                bottom
                left
                nudge-bottom="35"
                nudge-left="5"
                ma-0
                pa-0
              )
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    small
                    fab
                    :ripple="false"
                    depressed
                    v-on="on"
                    v-bind="attrs"
                    color="white"
                  )
                    v-icon(color="blue-grey lighten-1") mdi-tag
                v-list(dark dense style="background-color: #424242" min-width="120px")
                  v-list-item(class="tw-p-0")
                    v-btn(
                      small
                      left
                      tile
                      block
                      pa-0
                      ma-0
                      text
                      @click="setType(1)"
                      class=" tw-items-center tw-justify-start tw-my-1 "
                    )
                      div
                        v-icon mdi-phone
                        span(class="tw-pl-1") Call
                  v-list-item(class="tw-p-0")
                    v-btn(
                      small
                      left
                      tile
                      block
                      pa-0
                      ma-0
                      text
                      @click="setType(2)"
                      class=" tw-items-center tw-justify-start tw-my-0 "
                    )
                      div
                        v-icon mdi-calendar
                        span(class="tw-pl-1") Meeting
                  v-list-item(class="tw-p-0")
                    v-btn(
                      small
                      left
                      tile
                      block
                      pa-0
                      ma-0
                      text
                      @click="setType(3)"
                      class=" tw-items-center tw-justify-start tw-my-0 "
                    )
                      div
                        v-icon mdi-email
                        span(class="tw-pl-1") Email
              div(v-if="taskLabel" class=" tw-inline-block ")
                span {{ taskLabel }}
            v-col(cols="auto")
              v-menu(bottom left rounded="xl" nudge-bottom="35")
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    fab
                    small
                    :ripple="false"
                    v-on="on"
                    v-bind="attrs"
                    depressed
                    color="white"
                  )
                    v-icon(color="blue-grey lighten-1") mdi-calendar
                v-date-picker(
                  flat
                  no-title
                  dark
                  v-model="task.due_date"
                  locale="en"
                  :min="this.$moment().format('YYYY-MM-DD')"
                  :max="this.$moment().add(5, 'years').format('YYYY-MM-DD')"
                  elevation="0"
                  class=" tw-border-none tw-rounded-sm"
                )
              template(v-if="task.due_date" class="tw-inline-block")
                span(class="tw-pr-2") {{ dueDateLabel }}
            v-col(cols="auto" class="tw-mr-2")
              v-btn(
                fab
                small
                :ripple="true"
                @click="submit()"
                depressed
                color="indigo lighten-5"
                class="tw-ml-1"
              )
                v-icon(x-large color="indigo lighten-1") mdi-plus
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      task: {
        status: 0,
        name: null,
        type: null,
        due_date: null,
      },
      taskLabel: '',
      valid: true,
    };
  },
  computed: {
    opportunity() {
      return this.$route.params.id;
    },
    dueDateLabel() {
      return this.$moment(this.task.due_date).format('MMM Do YYYY');
    },
  },
  mounted() {},
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    setType(type) {
      this.task.type = type;
      switch (type) {
        case 1:
          this.taskLabel = 'Call';
          break;
        case 2:
          this.taskLabel = 'Meeting';
          break;
        case 3:
          this.taskLabel = 'Email';
          break;
        default:
          break;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch('opportunities/tasks/add', [this.opportunity, this.task])
          .then(() => {
            this.task = {};
            this.loading = false;
          })
          .catch((error) => {
            commit('SET_ERROR', error, { root: true });
          });
      }
    },
  },
};
</script>
